import { render, staticRenderFns } from "./AccrualsEstimatesLoader.vue?vue&type=template&id=2d72f359&scoped=true"
import script from "./AccrualsEstimatesLoader.vue?vue&type=script&lang=js"
export * from "./AccrualsEstimatesLoader.vue?vue&type=script&lang=js"
import style0 from "./AccrualsEstimatesLoader.vue?vue&type=style&index=0&id=2d72f359&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d72f359",
  null
  
)

export default component.exports